var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center"},[_c('a',{on:{"click":_vm.authenticate}},[_c('img',{attrs:{"src":require("@/assets/google-signin.png"),"width":"191"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }